/**
 * Detects if the app is running in a mobile webview
 * @returns true if running in a webview, false otherwise
 */
export function isWebview(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as { opera?: string }).opera ||
    '';

  // Check for URL parameter (mobile apps might pass this)
  const urlParams = new URLSearchParams(window.location.search);
  if (
    urlParams.get('webview') === 'true' ||
    urlParams.get('isWebview') === 'true'
  ) {
    return true;
  }

  // iOS webview detection: Contains "Mobile" but doesn't contain "Safari"
  // (iOS webview removes Safari from user agent)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  if (isIOS) {
    const hasMobile = /Mobile/.test(userAgent);
    const hasSafari = /Safari/.test(userAgent);
    if (hasMobile && !hasSafari) {
      return true;
    }
  }

  // Android webview detection: Contains "wv" (Android 5.0+ webview identifier)
  const isAndroid = /Android/.test(userAgent);
  if (isAndroid && /wv/.test(userAgent)) {
    return true;
  }

  // Check for common webview indicators in user agent
  const webviewPatterns = [
    /WebView/i,
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i,
    /Android.*Version\/\d+\.\d+(?!.*Chrome)/i,
  ];

  if (webviewPatterns.some(pattern => pattern.test(userAgent))) {
    return true;
  }

  // Check for custom window properties that mobile apps might inject
  const windowWithExtras = window as {
    ReactNativeWebView?: unknown;
    webkit?: {
      messageHandlers?: unknown;
    };
  };

  if (
    windowWithExtras.ReactNativeWebView ||
    windowWithExtras.webkit?.messageHandlers
  ) {
    return true;
  }

  return false;
}
